export default __webpack_public_path__ + "static/media/reddit.45f87929.jpeg";